import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "video-meeting-attachment" }
const _hoisted_2 = { class: "video-meeting-attachment__content" }
const _hoisted_3 = { class: "video-meeting-attachment__info" }
const _hoisted_4 = {
  key: 0,
  class: "video-meeting-attachment__time"
}
const _hoisted_5 = {
  key: 1,
  class: "video-meeting-attachment__duration"
}
const _hoisted_6 = ["href"]

import type { Attachment } from "@/dtos/Unipile.dto";
import { Icon } from "@iconify/vue";

interface Props {
  attachment: Attachment;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VideoMeetingAttachment',
  props: {
    attachment: {}
  },
  setup(__props: any) {



const formatDuration = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  }
  return `${minutes}:${secs.toString().padStart(2, "0")}`;
};

const formatMeetingTime = (timestamp: number): string => {
  const date = new Date(timestamp * 1000);
  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Icon), {
        icon: "mdi:video",
        class: "video-meeting-attachment__icon"
      }),
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "video-meeting-attachment__label" }, "Video Meeting", -1)),
        (__props.attachment.starts_at)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(formatMeetingTime(__props.attachment.starts_at)), 1))
          : _createCommentVNode("", true),
        (__props.attachment.time_range)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Duration: " + _toDisplayString(formatDuration(__props.attachment.time_range)), 1))
          : _createCommentVNode("", true)
      ]),
      (__props.attachment.url)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: __props.attachment.url,
            target: "_blank",
            class: "video-meeting-attachment__join",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createVNode(_unref(Icon), { icon: "mdi:video-plus" }),
            _cache[2] || (_cache[2] = _createElementVNode("span", null, "Join Meeting", -1))
          ], 8, _hoisted_6))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})